import { render, staticRenderFns } from "./DocumentQuickActions.vue?vue&type=template&id=7b6161e2"
import script from "./DocumentQuickActions.vue?vue&type=script&lang=js"
export * from "./DocumentQuickActions.vue?vue&type=script&lang=js"
import style0 from "./DocumentQuickActions.vue?vue&type=style&index=0&id=7b6161e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports